{
  "name": "porsche",
  "private": true,
  "type": "module",
  "version": "0.0.0",
  "description": "",
  "scripts": {
    "dev": "vite --host --port=5174",
    "build": "vite build",
    "preview": "vite preview",
    "test": "echo \"Error: no test specified\" && exit 1",
    "typecheck": "vue-tsc --noEmit -p tsconfig.json --composite false"
  },
  "prettier": "prettier-config",
  "dependencies": {
    "@discover/components": "workspace:*",
    "@discover/shared": "workspace:*",
    "tsconfig": "workspace:*"
  }
}
